import { render, staticRenderFns } from "./ImageHomeworkCreator.vue?vue&type=template&id=1964b8e5&scoped=true"
import script from "./ImageHomeworkCreator.vue?vue&type=script&lang=js"
export * from "./ImageHomeworkCreator.vue?vue&type=script&lang=js"
import style0 from "./ImageHomeworkCreator.vue?vue&type=style&index=0&id=1964b8e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1964b8e5",
  null
  
)

export default component.exports